import React from 'react';
import { Zap } from 'lucide-react';

const MSG = ['TALESVERSE', 'MEMORIES MARKET', 'OPEN CALL'];

function Row({ ariaHidden = false }) {
  return (
    <div className="marquee__track" aria-hidden={ariaHidden}>
      {Array.from({ length: 4 }).flatMap((_, i) =>
        MSG.map((m, j) => (
          <div key={`${i}-${j}`} className="flex items-center gap-8 whitespace-nowrap">
            <span className="font-display text-[13px] md:text-[14px] tracking-widest font-black uppercase">{m}</span>
            <Zap className="w-4 h-4 text-[#F5C518]" fill="#F5C518" strokeWidth={2} />
          </div>
        ))
      )}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="marquee">
      <Row />
      <Row ariaHidden />
    </div>
  );
}
